'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dialog = require('../Dialog/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _ViewGroup = require('../ViewGroup/ViewGroup');

var _ViewGroup2 = _interopRequireDefault(_ViewGroup);

var _FormGroup = require('./FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _util = require('@its/util');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    _this.state = {
      open: false
    };

    _this.messages = (0, _reactIntl.defineMessages)({
      ATTENTION: {
        id: 'ATTENTION',
        description: 'Notify attetion to dialog',
        defaultMessage: 'Attention'
      },
      CONFIRM_EXIT: {
        id: 'CONFIRM_EXIT',
        description: 'Confirm exit to user',
        defaultMessage: 'Are you sure want to leave?'
      }
    });

    _this.divStyle = {
      position: 'relative',
      display: 'block',
      width: '100%'
    };

    _this.margin = {
      marginLeft: '8px',
      marginRight: '8px'
    };

    _this.formStyle = (0, _util.merge)({
      minWidth: '80%',
      display: 'table',
      margin: '0 auto'
    }, props.style);

    _this.containerStyle = (0, _util.merge)(_this.divStyle, {
      paddingTop: '16px',
      paddingBottom: '16px'
    });
    _this.footerStyle = (0, _util.merge)(_this.divStyle, {
      textAlign: 'right',
      paddingRight: '25px'
    });

    _this.getGroups = _this.getGroups.bind(_this);
    _this.renderGroup = _this.renderGroup.bind(_this);
    _this.getViewGroup = _this.getViewGroup.bind(_this);
    _this.getViewGroupElement = _this.getViewGroupElement.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleCloseSubmit = _this.handleClose.bind(_this, true, true);
    _this.attentionMessage = props.intl.formatMessage(_this.messages.ATTENTION);
    _this.confirmExitMessage = props.intl.formatMessage(_this.messages.CONFIRM_EXIT);
    _this.onCancelButton = props.confirmExit ? _this.handleOpen : props.onCancel;

    _this.groups = props.groups.map(function (group) {
      return _this.renderGroup(group, props.fields);
    });
    return _this;
  }

  _createClass(Form, [{
    key: 'getViewGroupElement',
    value: function getViewGroupElement(group, fieldsInfo) {
      var _this2 = this;

      var result = void 0;
      if (Array.isArray(group)) {
        for (var i = 0; i < group.length; i++) {
          var getElement = function getElement(x) {
            return _this2.getViewGroupElement(x, fieldsInfo);
          };
          result = group.map(getElement);
        }
      } else {
        var title = group.title,
            others = _objectWithoutProperties(group, ['title']);

        result = _react2.default.createElement(_FormGroup2.default, _extends({ fieldsInfo: fieldsInfo }, others));
      }
      return result;
    }
  }, {
    key: 'getViewGroup',
    value: function getViewGroup(group, fieldsInfo, index) {
      var viewGroup = {
        key: null,
        title: null,
        element: null
      };
      if (Array.isArray(group)) {
        viewGroup.key = index + 1;
        viewGroup.title = index + 1;
      } else {
        var title = group.title,
            others = _objectWithoutProperties(group, ['title']);

        viewGroup.key = group.key;
        viewGroup.title = title;
      }
      viewGroup.element = this.getViewGroupElement(group, fieldsInfo);
      return viewGroup;
    }
  }, {
    key: 'getGroups',
    value: function getGroups(fieldsInfo) {
      return this.groups.map(function (element) {
        return _react2.default.cloneElement(element, { fieldsInfo: fieldsInfo });
      });
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen() {
      this.setState({ open: true });
    }
  }, {
    key: 'handleClose',
    value: function handleClose(button, submit) {
      this.setState({ open: false });
      if (submit && this.props.onCancel) {
        this.props.onCancel();
      }
    }
  }, {
    key: 'renderGroup',
    value: function renderGroup(group, fieldsInfo) {
      var result = void 0;
      if (Array.isArray(group)) {
        var items = [];
        for (var i = 0; i < group.length; i++) {
          items.push(this.getViewGroup(group[i], fieldsInfo, i));
        }
        result = _react2.default.createElement(_ViewGroup2.default, { key: 'viewGroup', groups: items });
      } else {
        result = _react2.default.createElement(_FormGroup2.default, _extends({ fieldsInfo: fieldsInfo }, group));
      }
      return result;
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          groups = _props.groups,
          fields = _props.fields,
          submitText = _props.submitText,
          cancelText = _props.cancelText,
          hideCancel = _props.hideCancel,
          hideSubmit = _props.hideSubmit,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit,
          handleSubmit = _props.handleSubmit,
          confirmExit = _props.confirmExit,
          submitDisabled = _props.submitDisabled,
          style = _props.style,
          others = _objectWithoutProperties(_props, ['groups', 'fields', 'submitText', 'cancelText', 'hideCancel', 'hideSubmit', 'onCancel', 'onSubmit', 'handleSubmit', 'confirmExit', 'submitDisabled', 'style']);

      return _react2.default.createElement(
        'form',
        _extends({
          onSubmit: handleSubmit,
          style: this.formStyle,
          onChange: this.stopPropagation
        }, others),
        _react2.default.createElement(
          _Paper2.default,
          { zDepth: 0, style: this.containerStyle },
          _react2.default.createElement(
            _Paper2.default,
            { zDepth: 0 },
            this.getGroups(fields)
          ),
          _react2.default.createElement(
            _Paper2.default,
            { zDepth: 0, style: this.footerStyle },
            hideCancel ? null : _react2.default.createElement(_RaisedButton2.default, {
              label: cancelText,
              style: this.margin,
              onMouseUp: this.onCancelButton,
              onTouchEnd: this.onCancelButton,
              secondary: true
            }),
            hideSubmit ? null : _react2.default.createElement(_RaisedButton2.default, {
              type: 'submit',
              label: submitText,
              disabled: submitDisabled,
              primary: true
            })
          )
        ),
        _react2.default.createElement(
          _Dialog2.default,
          {
            open: this.state.open,
            onRequestClose: this.handleClose,
            onCancel: this.handleClose,
            onSubmit: this.handleCloseSubmit,
            title: this.attentionMessage,
            cancel: true,
            submit: true
          },
          this.confirmExitMessage
        )
      );
    }
  }]);

  return Form;
}(_react2.default.Component);

Form.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  fields: _react2.default.PropTypes.object.isRequired,
  groups: _react2.default.PropTypes.array.isRequired,
  submitText: _react2.default.PropTypes.object.isRequired,
  cancelText: _react2.default.PropTypes.object.isRequired,
  onCancel: _react2.default.PropTypes.func.isRequired,
  onSubmit: _react2.default.PropTypes.func.isRequired,
  confirmExit: _react2.default.PropTypes.bool.isRequired,
  hideSubmit: _react2.default.PropTypes.bool,
  hideCancel: _react2.default.PropTypes.bool,
  style: _react2.default.PropTypes.object
};
Form.defaultProps = {
  fields: {},
  groups: [],
  submitText: 'SUBMIT',
  cancelText: 'CANCEL',
  confirmExit: true,
  hideSubmit: false,
  hideCancel: false,
  style: {}
};
exports.default = (0, _reactIntl.injectIntl)(Form);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Form/Form.js
 ** module id = 492
 ** module chunks = 0
 **/